// Back-link hook shared by detail pages (party, document).
//
// React-Router-6 stamps a numeric `idx` onto history.state for every
// entry it pushes. If we landed on this page from a router navigation
// the idx is > 0 and `navigate(-1)` returns the user to the previous
// page with its scroll position and any query-param state preserved.
//
// If idx is missing or 0 — fresh page load, refresh, or external
// link — there is nothing meaningful to go back to. Fall back to a
// sensible default rather than dumping the user on a blank screen.

import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export function useGoBack(fallback: string = '/mi/aois'): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  }, [navigate, fallback]);
}
